import { BASE_URL } from '../utils/constant';
import { localStore } from '../App';

class IslandsService 
{


  async fetchIslands(): Promise<any> 
  {
    const remoteIslands = await this.fetchRemoteIslands();
    if (remoteIslands) 
    {
      console.log('fetchIslands:: Informazioni sulle isole ecologiche scaricarte dal server.');
      return remoteIslands;
    }
    return this.fetchIslandsFromStorage();
  }


  async fetchIslandsFromStorage(): Promise<any> 
  {
    try 
    {
      console.log('fetchIslandsFromStorage:: cerco informazioni sulle isole ecologiche in memoria');
      
      const islands = await localStore.get("islandslist");
      if (islands != null) 
      {
        console.log('fetchIslandsFromStorage:: Informazioni sulle isole ecologiche presenti in memoria.');
        return islands;
      }

      console.log('Non sono presenti informazioni sulle isole ecologiche in memoria - riavviare l\'app e  riprovare');
      return null;
    }
    catch (error) 
    {
      console.log('Problema nella ricezione dei dati sulle isole ecologiche - riavviare l\'app e riprovare ', error);
      throw error;
    }
  }


  
  async fetchRemoteIslands(): Promise<[any] | null> 
  {
    console.log('fetchRemoteIslands:: cerco isole ecologiche sul server');

    return new Promise((resolve, reject) => {
      const url = `${BASE_URL}/poServer.php?act=5&h=gkzLoFk0MN58TGqCJj`;
      fetch(url)
        .then(res => res.json())
        .then(
          (result) => 
          {
            console.log('Informazioni sulle isole ecologiche scaricarte dal server.');
            localStore.set('islandslist', result.content);
            resolve(result.content);
          },
          (error) => {
            console.log('Problema nella ricezione dei dati sulle isole ecologiche - controlliamo se ce ne sono in memoria ', error);
            resolve(null);
          }
        );
    });
  }
}

export default IslandsService; 